import { ComponentMap } from '@cinch-nx/data-storyblok'
import {
  NextImage,
  RichText,
  IconWithText,
  CtaButton,
  Button,
} from '../atom-blocks'
import {
  FinanceRepresentativeExample,
  UsedCarsFinanceRepresentativeExample,
} from '@cinch-nx/ui-finance'

export const atomStoryblokComponents: ComponentMap = {
  CtaButton,
  FinanceRepresentativeExample,
  UsedCarsFinanceRepresentativeExample,
  Image_v2: NextImage,
  RichText,
  IconWithText,
  DS_Button: Button,
}
